<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form[fieldKey]" hidden/>

      <t-form-tab title="Dados Básicos">

        <t-input v-model="form.name"  :add-error="error.name" label="Nome" required/>

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status" class="mb-2"/>

      </t-form-tab>

      <template #out-of-form>

        <t-form-tab title="Grupos de Produtos" hash="group-product" :disabled="!relationAccessPageGeneral('product-group-product')" lazy>
          <GroupProduct :foreign-key="form[fieldKey]"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import GroupProduct from "@/views/modules/product/GroupProduct";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'FamilyProductForm',
  components: {GroupProduct},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "familyProductId",
      form: {
        familyProductId: 0,
        familyProductNumber: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>